const HeroSkeleton = () => {
  return (
    <div className="w-full">
      <div className="relative h-[clamp(420px,60vh,620px)] w-full animate-pulse overflow-hidden rounded-2xl bg-[#1a1919]">
        <div className="absolute inset-0 flex flex-col justify-end p-6 sm:p-10 lg:p-14">
          <div className="h-4 w-24 rounded bg-[#2a2a2a]"></div>
          <div className="mt-4 h-10 w-2/3 rounded bg-[#2a2a2a] sm:h-12 lg:h-14"></div>
          <div className="mt-4 h-4 w-1/3 rounded bg-[#2a2a2a]"></div>
          <div className="mt-7 flex items-center gap-3">
            <div className="h-12 w-32 rounded-full bg-[#2a2a2a]"></div>
            <div className="h-12 w-12 rounded-full bg-[#2a2a2a]"></div>
            <div className="h-12 w-12 rounded-full bg-[#2a2a2a]"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSkeleton;
